<div>{{index}}</div>
<div *ngIf="isLoadingItem$ | async">
  <mat-spinner [diameter]="30"></mat-spinner>
</div>
<div *ngIf="salesOrderItem">{{salesOrderItem.articleName}}</div>
<div *ngIf="errorMessage">{{errorMessage}}</div>
<button mat-button *ngIf="barcode" matSuffix mat-icon-button aria-label="Clear" (click)="removeItem()">
  <mat-icon>&#xE5CD;</mat-icon>
</button>
